export interface State {
  lastRouteBeforeSelfService?: string;
}

export const initialState: State = {};

const SET_LAST_ROUTE_BEFORE_SELF_SERVICE = 'selfService/lastRoute';
export const setLastRoute = (path: string) => ({type: SET_LAST_ROUTE_BEFORE_SELF_SERVICE, payload: path});

const selfService = (state: State = initialState, action: any) => {
  const {type, payload} = action;
  switch (type) {
    case SET_LAST_ROUTE_BEFORE_SELF_SERVICE:
      return {...state, lastRouteBeforeSelfService: payload};
    default:
      return state;
  }
};

export default selfService;
